import { render } from "./Badge.atoms.vue?vue&type=template&id=79c4c085&scoped=true&ts=true"
import script from "./Badge.atoms.vue?vue&type=script&lang=ts"
export * from "./Badge.atoms.vue?vue&type=script&lang=ts"

import "./Badge.atoms.vue?vue&type=style&index=0&id=79c4c085&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79c4c085"]])

export default __exports__